import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import csc from 'country-state-city';
import {
  customSelectStyles,
} from '../../../utils';

export default function City(props) {
  const [cityOptions, setCityOptions] = useState([]);
  const {
    value, onChange, disabled, state,
  } = props;
  const getCityOptions = (val) => {
    const options = csc.getCitiesOfState(val);
    const updateCityOptions = options.map((city) => ({
      label: city.name,
      value: city.id,
    }));
    setCityOptions(updateCityOptions);
  };

  useEffect(() => {
    state && getCityOptions(props.state.value);
  }, [state, props]);

  return (
    <Select
      placeholder="Select city"
      className="reactSelect"
      name="city"
      styles={customSelectStyles}
      onChange={onChange}
      options={cityOptions}
      value={value}
      isDisabled={disabled}
    />
  );
}

City.propTypes = {
  state: PropTypes.shape({ label: PropTypes.string, value: PropTypes.string }),
  disabled: PropTypes.bool,
  value: PropTypes.shape({ label: PropTypes.string, value: PropTypes.string }),
  onChange: PropTypes.func.isRequired,
};

City.defaultProps = {
  disabled: false,
  value: null,
  state: null,
};
